/**
 * Strip fields from a cloned record that should not be passed to the create form.
 * CloneButton JSON-stringifies the record into the create URL `source` query param.
 */
const sanitizeCloneRecord = (record) => {
    if (!record) {
        return record;
    }

    const {
        author,
        platform_products,
        record_revisions,
        resource_id,
        ...rest
    } = record;

    const sanitized = { ...rest };

    if (sanitized.resource) {
        const { id, ...resourceRest } = sanitized.resource;
        sanitized.resource = resourceRest;
    }

    if (sanitized.feed_item) {
        const { id, ...feedItemRest } = sanitized.feed_item;
        sanitized.feed_item = feedItemRest;
    }

    const fieldsToSlug = ['products', 'states', 'sales_channels'];
    fieldsToSlug.forEach((field) => {
        if (Array.isArray(sanitized[field])) {
            sanitized[field] = sanitized[field].map((item) => {
                if (item && typeof item === 'object') {
                    return item.slug || item.id;
                }

                return item;
            });
        }
    });

    const fieldsToId = ['brands', 'co_branded_video_logos', 'tags', 'platforms'];
    fieldsToId.forEach((field) => {
        if (Array.isArray(sanitized[field])) {
            sanitized[field] = sanitized[field].map((item) => {
                if (item && typeof item === 'object') {
                    return item.id || item.slug;
                }

                return item;
            });
        }
    });

    return sanitized;
};

export default sanitizeCloneRecord;
